import React from 'react';
import styled from 'styled-components';
import { EPageType } from '../../types/pages/things-to-do';
import { convertMarkdownToHtml } from '../../utils/getHtmlFromMarkdown';

interface IProps {
  requirementSection?: {
    title: string;
    requirements: string[];
  };
  faqSection?: {
    question: string;
    answer: string;
  };
  index: number;
  isOpen: boolean;
  sectionType: string;
  pageType?: string;
  toggleSection: () => void;
}
const ContentStyle = styled.div`
  animation: slowDown 500ms linear forwards;
  @keyframes slowDown {
    0% {
      transform: scaleY(0);
    }
    80% {
      transform: scaleY(1.1);
    }
    100% {
      transform: scaleY(1);
    }
  }
`;

const FAQs = ({
  pageType,
  requirementSection,
  faqSection,
  index,
  isOpen,
  sectionType,
  toggleSection
}: IProps) => {
  const BorderStyle = styled.div`
    border-bottom: 1px solid
      ${pageType === EPageType.THINGS_TODO
        ? 'gray'
        : sectionType === 'requirement'
        ? 'black'
        : 'white'};
    margin-bottom: ${isOpen ? '0px' : '2px'};
    opacity: ${pageType === EPageType.THINGS_TODO ? '0.25' : '1'};
  `;

  return (
    <div
      key={index}
      className={`xxsm:py-3 sm:py-4 ${
        pageType === EPageType.THINGS_TODO
          ? `w-full`
          : `xl:w-[60%] xxsm:w-[80%] md:w-[70%] px-4`
      } `}
    >
      <div
        className="py-2 flex xxsm:items-start sm:items-center cursor-pointer justify-between"
        onClick={() => toggleSection()}
      >
        <div
          className={`flex-1 ${
            pageType === EPageType.THINGS_TODO
              ? ' text-black text-base 2xl:text-lg font-medium 2xl:font-semibold leading-snug xxsm:pr-2.5 sm:pr-0'
              : ' font-semibold xsm:text-[18px] md:text-[22px] xl:text-2xl'
          }  ${sectionType === 'requirement' ? 'text-black' : 'text-white'}`}
        >
          {requirementSection?.title || faqSection?.question}
        </div>
        <div className="flex items-center">
          <div
            className={`xl:text-2xl xxsm:text-xl md:text-2xl ${
              sectionType === 'requirement' ? 'text-black' : 'text-white'
            } transform transition-transform duration-300 ${
              isOpen ? 'rotate-45' : 'rotate-0'
            } cursor-pointer`}
          >
            +
          </div>
        </div>
      </div>
      {isOpen && (
        <ContentStyle
          className={requirementSection?.title ? 'pt-2 text-xl' : 'py-6'}
          style={{ color: sectionType === 'requirement' ? 'black' : 'white' }}
        >
          <p className="xxsm:text-[14px] md:text-[20px]">
            {requirementSection?.title}
            {requirementSection?.title
              ? 's are expected to have the following requirements:'
              : ''}
          </p>
          {requirementSection?.requirements && (
            <ul className="list-disc pl-10 py-6 xxsm:text-[14px] md:text-[20px]">
              {requirementSection?.requirements.map((requirement, i) => (
                <li className={requirementSection?.title ? 'mb-2' : ''} key={i}>
                  {requirement}
                </li>
              ))}
            </ul>
          )}
          {faqSection?.answer && (
            <p
              className={` things-to-do-faq ${
                pageType === EPageType.THINGS_TODO
                  ? `text-zinc-700 text-opacity-90 sm:text-sm md:text-base 2xl:text-lg font-normal leading-snug`
                  : `xxsm:text-[14px] md:text-[20px] leading-10 mb-2`
              } `}
              dangerouslySetInnerHTML={{
                __html: convertMarkdownToHtml(faqSection?.answer)
              }}
            ></p>
          )}
        </ContentStyle>
      )}
      <BorderStyle />
    </div>
  );
};

export default FAQs;
